import React from "react";
import { useFormik } from "formik"
import * as Yup from "yup"
import { cn, Input } from "@heroui/react";
import { Button } from 'src/shared/components/Button';
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { verify_recaptcha_token } from "src/services/api/verifiers/verifiers_requests";
import { Search } from "lucide-react";

const FindPart = () => {

  const { executeRecaptcha } = useGoogleReCaptcha();

  const onSearchPart = async (form_data) => {
    if (!executeRecaptcha) {
      console.log('Execute recaptcha not yet available');
      return;
    }

    const recaptcha_token = await executeRecaptcha('submitForm');

    verify_recaptcha_token(recaptcha_token).then((response) => {
      const { success } = response
      if(success) {
        const { keywords } = form_data;
        window.location.href = `/find-part/${keywords}`;
      } 
    }).catch((err) => {
      console.log(err)
    })
  }

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      keywords: '',
    },
    validationSchema: Yup.object({
      keywords: Yup.string().required('Field is required').min(3, "Field must be 3 characters or more"),
    }),
    onSubmit: onSearchPart,
  })

  return (
    <form 
      autoComplete="off"
      onSubmit={formik.handleSubmit}>
      <div className="flex gap-4">
        <Input 
          classNames={{
            input: 'text-[1rem]',
            inputWrapper: 'h-12',
            base: cn([
              '[&>.hidden]:text-[#FFFFFF]'
            ])
          }} 
          placeholder="Enter a part number"
          isInvalid={formik.touched.keywords && !!formik.errors.keywords}
          errorMessage={formik.touched.keywords && formik.errors.keywords}
          {...formik.getFieldProps('keywords')}
        />
        <Button
          className={cn([
            "h-12 text-white text-lg font-extrabold",
            "bg-[#007CA1] hover:bg-[#005D7B] active:bg-[#004A63]",
          ])}
          type="submit">
            <span className='inline-flex items-center justify-center px-[1.59375rem] py-[0.6875rem]'>
              Find Part&nbsp;<Search size={24} strokeWidth={2} />
            </span>
        </Button>
      </div>
    </form>
    

  )
}

export default FindPart;
